<template>
  <navbar :username="username" :role="role" @ToRoot="shows = 4" @ToFiles="shows = 16"
    @NewsEditBtn="shows = 256" @UsersBtn="shows = 64" @RadioCompBtn="shows = 128"
    @LoginBtn="LoginBtnClbk" @LogoutBtn="LogoutBtnClbk" @RegBtn="shows = 2" :loginOk="loginOk" />
  <filemgr v-if="(this.shows >> 4) & 1" :username="username" @needRender="RenderFileMgr" :key="fileKey" />
  <about v-if="(this.shows >> 3) & 1" />
  <news v-if="(this.shows >> 2) & 1" />
  <users v-if="(this.shows >> 6) & 1" />
  <comps v-if="(this.shows >> 7) & 1" />
  <news_edit v-if="(this.shows >> 8) & 1" />
  <reg v-if="(this.shows >> 1) & 1" @RegOk="RegOkClbk" />
</template>

<script>
import navbar from './components/navbar.vue'
import filemgr from './components/filemgr.vue'
import reg from './components/registration.vue'
import about from './components/about.vue'
import news from './components/news.vue'
import users from './components/users.vue'
import comps from './components/comps.vue'
import news_edit from './components/db_news.vue'

export default {
  name: 'App',
  components: {
    navbar,
    filemgr,
    reg,
    about,
    news,
    users,
    comps,
    news_edit
  },
  data() {
    return {
      shows: 4,
      // shows:
      // login      = 1   (0) not used since 2.0.5
      // reg        = 2   (1)
      // news       = 4   (2)
      // about      = 8   (3)
      // filemgr    = 16  (4)
      // webcam     = 32  (5) not used since 2.0.5
      // users      = 64  (6)
      // radiocomps = 128 (7)
      // news_edit  = 256 (8)
      loginOk: false,
      role: 0,
      username: "None",
      fileKey: 0,
      cmShow: false
    }
  },
  methods: {
    LogoutBtnClbk() {
      this.shows = 4
      this.role = 0
      this.loginOk = false
      fetch("https://api.bormart.ru/logout", {
        credentials: "include"
      })
    },
    LoginBtnClbk() {
      window.location.href = "https://api.bormart.ru/login/?origin=www.bormart.ru"
    },
    RegBtnClbk() {
      this.shows = 2
    },
    RegOkClbk() {
      window.location.href = "https://api.bormart.ru/login/?origin=www.bormart.ru"
    },
    LoginOkClbk(data) {
      this.role = data["role"]
      this.shows = 16 * ((this.role >> 1) & 1) + 4 * !((this.role >> 1) & 1)
      this.loginOk = true
      this.username = data["nick"]
    },
    RenderFileMgr() {
      if (this.fileKey < 5) {
        this.fileKey += 1
      } else {
        this.fileKey = 0
      }
    }
  },
  mounted() {
    if (window.location.search != '') {
      var params = window
                        .location
                        .search
                        .replace('?','')
                        .split('&')
                        .reduce(
                            function(p,e) {
                                var a = e.split('=');
                                p[ decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
                                return p;
                            },
                            {}
                  );
      this.LoginOkClbk(params)
    } else {
      fetch("https://api.bormart.ru/auth", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                "Cookie": document.cookie
            },
            body: JSON.stringify({
                "auto": 1
            })
            }).then((response) => {
                return response.json()
            }).then((data) => {
            if (data["ok"] == 1) {
              this.LoginOkClbk(data)
            }
        })
    }
  }
}
</script>

<style>
@import "../public/static/css/style.css";
</style>